export const compareKeyBySelect = (options, content) => {
  const { text } = options.find(({ key }) => key === content);

  return text;
};
